export const hasWalletData = (walletAnalysis) => {
  if (!walletAnalysis) return false

  const grupos =
    (walletAnalysis.posicao_completa &&
      walletAnalysis.posicao_completa.grupos) ||
    []
  if (Array.isArray(grupos) && grupos.length > 0) return true

  const breakdownData =
    (walletAnalysis.breakdown && walletAnalysis.breakdown.data) || {}
  return Object.keys(breakdownData).length > 0
}
